export const ROUTES = {
  HOME: "/",
  HOME_WITH_PARAMS: "/project/:projectId/milestone/:milestoneId",
  LOGIN: "/login",
  AUTHORIZE_REDIRECT: "/authorize-redirect",
  USER_PROJECT_ACCESSES: "/user-access-to-projects",
};
